module.exports = __webpack_public_path__ + "static/img/Aions_GZ_Mar_6.b9cc5de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Aions_GZ_Mar/Aions_GZ_Mar_6.png
// module id = EQGQ
// module chunks = 19